export default {
  PASSWORD_REGEXP: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$/,
  NUMBER_ARRAY: /^[0-9,\s]*$/,
  HOSTS_ARRAY:
    /^((([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])([\s,]*?))*$/
}
